<!-- 召回通知单列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <cusAuthAction v-if="showStatus" ref="creditApplyAction" @drawerCancel="drawerCancel" @toDetail="toDetail"
                :actionData="actionData"></cusAuthAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
                @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData
                    v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
                <el-form @submit.native.prevent label-width="100px" :inline="true" size="mini" :model="getRequestData"
                    class="demo-form-inline">
                    <el-form-item label="开始时间" prop="start">
                        <el-date-picker v-model="getRequestData.start" type="date" placeholder="选择日期"
                            value-format="timestamp" format="yyyy 年 MM 月 dd 日"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="end">
                        <el-date-picker v-model="getRequestData.end" type="date" placeholder="选择日期"
                            value-format="timestamp" format="yyyy 年 MM 月 dd 日" @change="changeTime"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" size="mini" stripe :data="returnData.list"
                :height="tableHeight" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column prop="cmName" label="客户名称" min-width="120" align="center"
                    show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="bigLineClassList" label="产品线列表" min-width="200" align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.bigLineClassList">
                            {{scope.row.bigLineClassList.map(item => item.bgiLineClass).join()}}
                        </span>
                    </template>
</el-table-column>
<el-table-column prop="brandList" label="品牌列表" min-width="200" align="center" show-overflow-tooltip>
    <template slot-scope="scope">
                        <span v-if="scope.row.brandList">
                            {{scope.row.brandList.map(item => item.bgiBrand).join()}}
                        </span>
                    </template>
</el-table-column>
<el-table-column prop="customerList" label="终端客户列表" min-width="200" align="center" show-overflow-tooltip>
    <template slot-scope="scope">
                        <span v-if="scope.row.customerList">
                            {{scope.row.customerList.map(item => item.cmName).join()}}
                        </span>
                    </template>
</el-table-column>
<el-table-column prop="hospitalList" label="医院列表" min-width="200" align="center" show-overflow-tooltip>
    <template slot-scope="scope">
                        <span v-if="scope.row.hospitalList">
                            {{scope.row.hospitalList.map(item => item.name).join()}}
                        </span>
                    </template>
</el-table-column>
<el-table-column prop="registnoList" label="注册证列表" min-width="200" align="center" show-overflow-tooltip>
    <template slot-scope="scope">
                        <span v-if="scope.row.registnoList">
                            {{scope.row.registnoList.map(item => item.bgiRegistno).join()}}
                        </span>
                    </template>
</el-table-column> -->
                <el-table-column prop="authStart" label="授权开始时间" min-width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.authStart">
                            {{ $common.getLocalTime(scope.row.authStart) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="authEnd" label="授权结束时间" min-width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.authEnd">
                            {{ $common.getLocalTime(scope.row.authEnd) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="createrName" label="创建人" min-width="120" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" min-width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.updateTime">
                            {{ $common.getLocalTime(scope.row.updateTime) }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import cusAuthAction from '@/components/cusAuthAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        cusAuthAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,

            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            multipleSelection: [],
            showStatus: false,
            actionData: {},
            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },

        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },

        // 获取数据列表
        getPageInfo() {
            var obj = {}
            obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
            }
            this.getButtonList();
            this.getDataList();
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
                case 1:
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: "请勾选一条数据操作",
                            type: "error",
                        });
                        return false;
                    }
                    this.baseauthqueryDetail(0)
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 16:
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: "请勾选一条数据操作",
                            type: "error",
                        });
                        return false;
                    }
                    this.baseauthqueryDetail(1)
                    break;
            }
        },
        async baseauthqueryDetail(val) {
            var dataInfo = this.multipleSelection[0]
            var responseData = await this.$http.baseauthqueryDetail({ ids: [dataInfo.id] })
            if (responseData.status == 200) {
                this.showStatus = true
                this.actionData = {
                    cate: val==1?2:1,
                    formData: this.formDataList,
                    oldData: responseData.result,
                    orderId: responseData.result.id,
                    printSouce: '',
                    printJurId: ''
                }
            } else {
                this.$message({
                    message:responseData.message,
                    type: "error",
                });
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.baseauthquery(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.total = responseData.result.total;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: '暂无数据',
                    type: 'error'
                });
                return
            } else if (this.multipleSelection.length <= 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.baseauthdelete({ ids: this.multipleSelection.map(item => item.id) });
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>